/**
 * Created by Andrey Popov on 26.12.2025
 */
const AdvStartTutorial = function () {
    let step6SkipReason = "none";
    let step6AdvanceUnit = "notCalled";
    return new TutorialScenario(AdvStartTutorial.NAME, {
        listSteps: () => [
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: { code: "advbush", stage: 7 },
                text: "Tutorial.adv3bush7.step1",
                person: "worker",
                region: "tutorial_adv3_1"
            }),
            AdventureTutorialHelper.createWaitStep({
                event: Map2d.REMOVED_MINING,
                targets: { code: "advbush", stage: 7 }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: { code: "advbush", stage: 7 },
                person: "worker",
                text: "Tutorial.adv3bush7.step2",
                region: "tutorial_adv3_1"
            }),
            AdventureTutorialHelper.createWaitStep({
                event: Map2d.REMOVED_MINING,
                targets: { code: "advbush", stage: 7 }
            }),
            new TutorialStep({
                onStart: function () {
                    this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                        this.force = cleverapps.forces.create(undefined, {
                            target: "warehouse",
                            controls: ["WarehouseIcon"],
                            text: "Tutorial.adv3bush7.step3",
                            person: "worker"
                        });
                    }, 1500);

                    cleverapps.tutorial.on("warehouse_window_opened", () => {
                        this.finish();
                    }, this);
                },

                onFinish: function () {
                    if (this.forceTimeout) {
                        cleverapps.timeouts.clearTimeout(this.forceTimeout);
                        delete this.forceTimeout;
                    }
                    this.force && this.force.hideForceHints();
                    Map2dLocation.currentLocation.counter.trigger();
                },

                onCheckConditions: function (options) {
                    return options && options.advice === "openWarehouse";
                }
            }),
            new TutorialStep({
                onStart: function () {
                    const dialogue = cleverapps.focusManager.currentWindow().createDialogue({
                        text: "Tutorial.adv3bush7.step4",
                        items: true,
                        person: "worker",
                        closeHint: {
                            delay: 3
                        },
                        position: cleverapps.styles[cleverapps.meta.selectedLocationId()].warehouseTutorialMinimal[cleverapps.resolution.mode]
                    });
                    cleverapps.tutorial.on("warehouse_window_closed", () => {
                        dialogue.remove();
                        this.finish();
                    }, this);
                },

                onFinish: function () {
                    const customer = Map2d.currentMap.customers.listCustomers().find((c) => ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(c.unit.code));
                    if (customer && customer.getState() === Customer.STATE_EMPTY) {
                        customer.order();
                    }

                    Map2dLocation.currentLocation.counter.trigger(1);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.CLICK_UNIT,
                targets: [{ code: "rpcustomerbridge0", stage: 0 }, { code: "adv3rpcustomerbridge0", stage: 0 }],
                text: "Tutorial.adv3rpcustomerbridge0.step1",
                person: "worker",
                affected: true,
                force: Forces.BRIDGE_CLICK_FORCE,
                onSkip: (reason) => {
                    const bridge = Map2d.currentMap.listAvailableUnits({ code: "adv3rpcustomerbridge0" })
                        .concat(Map2d.currentMap.listAvailableUnits({ code: "rpcustomerbridge0" }))
                        .map((u) => `${u.code}_${u.stage} x:${u.x} y:${u.y}`).join("|") || "none";
                    step6SkipReason = `${reason},bridge:${bridge}`;
                },
                onAdvance: (unit) => {
                    step6AdvanceUnit = unit ? `${unit.code}_${unit.stage}` : "none";
                }
            }),
            new TutorialStep({
                onStart: function () {
                    const hadCustomer = !!Map2d.currentMap.customers.selectedCustomer;
                    this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                        const selectedCustomer = Map2d.currentMap.customers.selectedCustomer;
                        if (!selectedCustomer) {
                            const customersState = Map2d.currentMap.customers.listCustomers()
                                .map((c) => `${c.unit.code}_${c.unit.stage} state:${c.getState()} view:${c.getViewType()}`).join("|") || "none";
                            cleverapps.throwAsync([
                                "AdvStartTutorial: selectedCustomer lost",
                                `hadOnStart:${hadCustomer}`,
                                `step6skip:${step6SkipReason}`,
                                `step6advance:${step6AdvanceUnit}`,
                                `eventNodes:${cleverapps.focusManager.eventNodes.length}`,
                                `focused:${cleverapps.focusManager.isFocused()}`,
                                `customers:${customersState}`
                            ].join(", "));

                            this.finish();
                            return;
                        }
                        const unit = selectedCustomer.unit;
                        const ingredientsAdditionalView = unit.onGetView().getAdditionalView("extended_ingredients");
                        const help = ingredientsAdditionalView.view.customerIngredientViews[0].help;
                        this.force = cleverapps.forces.create(help, Forces.CUSTOMER_INGREDIENT_HELP);
                    }, 600);

                    cleverapps.tutorial.on("ingredientHelpClick", () => {
                        this.finish();
                    }, this);
                },

                onFinish: function () {
                    if (this.forceTimeout) {
                        cleverapps.timeouts.clearTimeout(this.forceTimeout);
                        delete this.forceTimeout;
                    }
                    this.force && this.force.hideForceHints();
                    Map2dLocation.currentLocation.counter.trigger();
                },
                onCheckConditions: function (options) {
                    options = options || {};
                    return options.unit && ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(options.unit.code);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: { code: "advlawn", stage: 2 },
                text: "Tutorial.adv3rpcustomerbridge0.step3",
                person: "worker",
                region: "tutorial_adv3_2",
                delay: 0.4
            }),
            AdventureTutorialHelper.createWaitStep({
                type: Map2d.COMPLETE_MINING,
                targets: { code: "advlawn", stage: 2 },
                wait: "5 seconds"
            })],
        manual: true
    });
};

AdvStartTutorial.NAME = "AdvStartTutorial";

const AdvShortTutorial = function () {
    return new TutorialScenario(AdvShortTutorial.NAME, {
        listSteps: () => [
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: { code: "advsource0", stage: 3 },
                person: "worker",
                text: "Tutorial.adv3bush7.step1",
                region: "tutorial_adv3_1",
                delay: 0.2
            }),
            new TutorialStep({
                onStart: function () {
                    const handler = cleverapps.tutorial.on(Map2d.REMOVED_MINING, (options) => {
                        if (!cleverapps.intersect({ code: "advsource0", stage: 3 }, options.unit, Unit.GetKey).length) {
                            return;
                        }

                        cleverapps.timeouts.setTimeout(() => {
                            const customer = Map2d.currentMap.customers.listCustomers().find((c) => ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(c.unit.code));
                            if (customer && customer.getState() !== Customer.STATE_RECIPE) {
                                customer.order();
                            }

                            this.finish();
                        }, 800);
                        handler.clear();
                    });
                },

                onFinish: function () {
                    Map2dLocation.currentLocation.counter.trigger(1);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.CLICK_UNIT,
                targets: [{ code: "rpcustomerbridge0", stage: 0 }, { code: "adv3rpcustomerbridge0", stage: 0 }],
                text: "Tutorial.adv3rpcustomerbridge0.step1",
                person: "worker",
                affected: true,
                force: Forces.BRIDGE_CLICK_FORCE
            }),
            new TutorialStep({
                onStart: function () {
                    this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                        const selectedCustomer = Map2d.currentMap.customers.selectedCustomer;
                        if (!selectedCustomer) {
                            this.finish();
                            return;
                        }
                        const unit = selectedCustomer.unit;
                        const ingredientsAdditionalView = unit.onGetView().getAdditionalView("extended_ingredients");
                        const help = ingredientsAdditionalView.view.customerIngredientViews[0].help;
                        this.force = cleverapps.forces.create(help, Forces.CUSTOMER_INGREDIENT_HELP);
                    }, 600);

                    cleverapps.tutorial.on("ingredientHelpClick", () => {
                        this.finish();
                    }, this);
                },

                onFinish: function () {
                    if (this.forceTimeout) {
                        cleverapps.timeouts.clearTimeout(this.forceTimeout);
                        delete this.forceTimeout;
                    }
                    this.force && this.force.hideForceHints();
                    Map2dLocation.currentLocation.counter.trigger();
                },
                onCheckConditions: function (options) {
                    options = options || {};
                    return options.unit && ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(options.unit.code);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: { code: "advlawn", stage: 2 },
                text: "Tutorial.adv3rpcustomerbridge0.step3",
                person: "worker",
                region: "tutorial_adv3_2",
                delay: 0.2
            }),
            AdventureTutorialHelper.createWaitStep({
                type: Map2d.COMPLETE_MINING,
                targets: { code: "advlawn", stage: 2 },
                wait: "5 seconds"
            })],
        manual: true
    });
};

AdvShortTutorial.NAME = "AdvShortTutorial";

const AdvShortTutorialIntroScene = function (expeditionName) {
    let firstSource = [];

    return new TutorialScenario(`${expeditionName}_tutorial`, {
        isAvailable: () => {
            const regions = Map2d.currentMap.regions;
            let available = false;
            for (const position of regions["tutorial_adv3_1"].positions) {
                if (Map2d.currentMap.isOccupiedByFog(position.x, position.y)) {
                    available = true;
                    break;
                }
            }
            return available;
        },
        listSteps: () => [
            AdventureTutorialHelper.createUnlockFogStep({ id: "fog0" }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: () => {
                    firstSource = AdventureTutorialHelper.regionTargets("tutorial_adv3_1", { code: "advsource0", stage: 3 });
                    return firstSource;
                },
                onSkip: () => {
                    firstSource = [];
                },
                person: "worker",
                text: "Tutorial.adv3bush7.step1",
                region: "tutorial_adv3_1",
                delay: 0.2
            }),
            new TutorialStep({
                onStart: function () {
                    const order = () => {
                        const customer = Map2d.currentMap.customers.listCustomers().find((c) => ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(c.unit.code));
                        if (customer && customer.getState() !== Customer.STATE_RECIPE) {
                            customer.order();
                        }

                        this.finish();
                    };

                    // nothing was mined in the first step: the map has no source in the tutorial region
                    if (!firstSource.length) {
                        order();
                        return;
                    }

                    const handler = cleverapps.tutorial.on(Map2d.REMOVED_MINING, (options) => {
                        if (!cleverapps.intersect(firstSource, options.unit, Unit.GetKey).length) {
                            return;
                        }

                        cleverapps.timeouts.setTimeout(order, 800);
                        handler.clear();
                    });
                },

                onFinish: function () {
                    Map2dLocation.currentLocation.counter.trigger(1);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.CLICK_UNIT,
                targets: [{ code: "rpcustomerbridge0", stage: 0 }, { code: "adv3rpcustomerbridge0", stage: 0 }],
                text: "Tutorial.adv3rpcustomerbridge0.step1",
                person: "worker",
                affected: true,
                force: Forces.BRIDGE_CLICK_FORCE
            }),
            new TutorialStep({
                onStart: function () {
                    this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                        const selectedCustomer = Map2d.currentMap.customers.selectedCustomer;
                        if (!selectedCustomer) {
                            this.finish();
                            return;
                        }
                        const unit = selectedCustomer.unit;
                        const ingredientsAdditionalView = unit.onGetView().getAdditionalView("extended_ingredients");
                        const help = ingredientsAdditionalView.view.customerIngredientViews[0].help;
                        this.force = cleverapps.forces.create(help, Forces.CUSTOMER_INGREDIENT_HELP);
                    }, 600);

                    cleverapps.tutorial.on("ingredientHelpClick", () => {
                        this.finish();
                    }, this);
                },

                onFinish: function () {
                    if (this.forceTimeout) {
                        cleverapps.timeouts.clearTimeout(this.forceTimeout);
                        delete this.forceTimeout;
                    }
                    this.force && this.force.hideForceHints();
                    Map2dLocation.currentLocation.counter.trigger();
                },
                onCheckConditions: function (options) {
                    options = options || {};
                    return options.unit && ["adv3rpcustomerbridge0", "rpcustomerbridge0"].includes(options.unit.code);
                }
            }),
            AdventureTutorialHelper.createAdviceStep({
                type: Map2d.START_MINING,
                targets: () => AdventureTutorialHelper.regionTargets("tutorial_adv3_1", { code: "advlawn", stage: 2 }),
                text: "Tutorial.adv3rpcustomerbridge0.step3",
                person: "worker",
                region: "tutorial_adv3_1",
                delay: 0.2
            }),
            AdventureTutorialHelper.createWaitStep({
                type: Map2d.COMPLETE_MINING,
                targets: { code: "advlawn", stage: 2 },
                wait: "5 seconds"
            })],
        manual: true
    });
};

Forces.CUSTOMER_INGREDIENT_HELP = {
    text: "Tutorial.adv2rpcustomerbridge0.step2",
    finger: true,
    person: "worker",
    shadow: {
        delay: 0
    }
};

Forces.BRIDGE_CLICK_FORCE = {
    finger: true,
    shadow: {
        delay: 0
    }
};

const AdvSpawnerTutorial = function () {
    return new TutorialScenario(AdvSpawnerTutorial.NAME, {
        manual: true,
        isAvailable: function () {
            return !cleverapps.focusManager.isFocused() && !cleverapps.forces.isShown(Forces.ADVENTURE_SPAWNER);
        },
        listSteps: AdvSpawnerTutorial.listSteps
    });
};

AdvSpawnerTutorial.NAME = "AdvSpawnerTutorial";

AdvSpawnerTutorial.listSteps = function () {
    const { spawners } = Spawner.getSpawners();
    const spawnerUnit = spawners[0].unit;
    const spawnerComponent = spawners[0];

    const steps = [{
        onStart: function () {
            spawnerUnit.hideAdditionalViews();

            Map2d.currentMap.focusOnUnit(spawnerUnit, {
                callback: () => this.finish()
            });
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            this.force = cleverapps.forces.create(spawnerUnit.view || ForceView.NO_ELEMENT, Forces.ADVENTURE_SPAWNER, {
                person: "worker"
            });

            cleverapps.forces.onceForceClosed = () => {
                this.force = undefined;
                this.finish();
            };
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            const guideData = spawnerUnit.getData().guide;
            const guideOptions = guideData[cleverapps.meta.selectedLocationId()] || guideData.default || guideData;
            new GuideWindow({
                ...guideOptions,
                closeButtonDelay: true
            }, spawnerUnit);
            cleverapps.focusManager.onceNoWindowsListener = this.finish.bind(this);
        },
        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            spawnerComponent.speedUpCharging();
            spawnerUnit.showAdditionalViews();
            this.finish();
        },
        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }];

    return steps.map((step) => new TutorialStep(step));
};